"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var dateFormatter_1 = require("../../../util/formatter/dateFormatter");
var printHeader_styles_1 = require("./printHeader.styles");
var luxon_1 = require("luxon");
var printHeader_i18n_1 = require("./printHeader.i18n");
var core_components_1 = require("@securityproducts/core-components");
function PrintHeader(props) {
    var createdDate = dateFormatter_1.newDateFormatterLuxon(luxon_1.DateTime.local(), "HOURS", "TOOLTIP", props.language);
    var strings = core_components_1.useLocalisation(printHeader_i18n_1.printHeaderRangeTranslations, props.language);
    return (React.createElement("div", { className: printHeader_styles_1.container },
        React.createElement("div", null,
            props.accountName && (React.createElement("span", null,
                strings.accountName,
                " ",
                React.createElement("b", null, props.accountName))),
            props.accountId && (React.createElement("span", null,
                strings.accountId,
                " ",
                React.createElement("b", null, props.accountId)))),
        React.createElement("div", null,
            strings.createdOn,
            " ",
            createdDate)));
}
exports.PrintHeader = PrintHeader;
